import axios from 'axios';
import React from 'react';
import { useTranslate } from '../../mixins/translate/translate';
import { PanelButtonLink } from '../elements';

export function DownloadReport(props: { url: string; text: string; reportTitle: string }) {
    const translateKey = useTranslate();
    const [isDownloading, setDownloading] = React.useState(false);

    async function downloadPdf(url: string) {
        setDownloading(true);
        const response = await axios.get(url, {
            responseType: 'blob',
            timeout: 1000 * 60 * 5,
        });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const filename = `${props.reportTitle}.pdf`;

        if (response.data) {
            const newUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = newUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        }
        setDownloading(false);
    }

    return (
        <>
            {(isDownloading && (
                <span className="ml10">
                    <span className="fw200 mr10">{translateKey('survey.generate')}</span>
                    <img src="/assets/img/spinner-amsterdam.svg" alt=" loading" height="35px" className="mr10" />
                </span>
            )) || <PanelButtonLink small mb0 icon="fa fa-download" text={props.text} onClick={async () => downloadPdf(props.url)} />}
        </>
    );
}
